import { Injectable } from '@angular/core';
import { SignatureSessionService } from '../services/signature-session.service';
import { StepperCanActivated } from './stepper-canActivated-model';
import { StepperActivationMessages } from '../../shared/models/component-messages/stepper-activation-messages';
import { ScwsService } from '../services/scws-service.service';
import { from, Observable } from 'rxjs';

declare var SCWS: any;


@Injectable()
export class StepperComponentActivationService {

  public stepperActivationMessages = new StepperActivationMessages();

  constructor(private signatureSession: SignatureSessionService, private scwsService: ScwsService) {
  }

  canActivate(componentName: string): Observable<StepperCanActivated> {
    return new Observable((observer) => {
      const stepperCanActivated: StepperCanActivated = new StepperCanActivated();
      let canActivate = true;
      let reason: string;
      if (componentName === "app-certificate" || componentName === "app-signature-parameters") {
        canActivate = this.signatureSession.signatureRequestData.documentToSign != null;
        reason = 'stepper.error_document';
        stepperCanActivated.canActivate = canActivate;
        stepperCanActivated.reason = reason;
        observer.next(stepperCanActivated);
      }
      else if (componentName === "app-certificate-dialog") {
          this.scwsService.getObjectsFromReaders().subscribe(data => {
            if (this.signatureSession.signatureCertificate != undefined && !this.signatureSession.signatureCertificate.isEmpty()) {
              canActivate = true;
              stepperCanActivated.canActivate = canActivate;
              stepperCanActivated.reason = reason;
              observer.next(stepperCanActivated);
            } else {
              canActivate = true;
              reason = 'stepper.error_certificate';
              stepperCanActivated.canActivate = canActivate;
              stepperCanActivated.reason = reason;
              observer.next(stepperCanActivated);
            }
          },
          err => {
            console.log("Stepper error : " + err);
            canActivate = true;
              reason = 'stepper.error_cert_remove';
              stepperCanActivated.canActivate = canActivate;
              stepperCanActivated.reason = reason;
              observer.next(stepperCanActivated);
          });
      } else {
        stepperCanActivated.canActivate = true;
        stepperCanActivated.reason = reason;
        observer.next(stepperCanActivated);
      }

    });
  }
}
